<template>
  <div>
    <div class="title">
      <div>修改密码</div>
      <div class="sub-title">
        密码至少6位，需由字母和数字组成。推荐使用大写字母和特殊符号提高安全性
      </div>
    </div>
    <el-form
      ref="pwdForm"
      :model="form"
      label-width="160px"
      label-position="left"
      :hide-required-asterisk="true"
      :show-message="false"
    >
      <reset-pwd-item
        v-model="form.password"
        :label="'原密码'"
        :prop="'password'"
        :placeholder="'请输入原密码'"
        :checkCode="ruleObj.password.code"
        :checkMessage="ruleObj.password.message"
        @blur="validateData('password')"
      />

      <reset-pwd-item
        v-model="form.newPassword"
        :label="'新密码'"
        :prop="'newPassword'"
        :placeholder="'请输入新密码'"
        :checkCode="ruleObj.newPassword.code"
        :checkMessage="ruleObj.newPassword.message"
        @blur="validateData('newPassword')"
      />

      <reset-pwd-item
        v-model="form.confirmPassword"
        :label="'确认密码'"
        :prop="'confirmPassword'"
        :placeholder="'请确认密码'"
        :checkCode="ruleObj.confirmPassword.code"
        :checkMessage="ruleObj.confirmPassword.message"
        @blur="validateData('confirmPassword')"
      />
    </el-form>
    <el-button type="success" @click="handleSubmit" style="width: 205px" :loading="loading">
      修改
    </el-button>
  </div>
</template>

<script >
import ResetPwdItem from './reset-pwd-item.vue';
import store from '@/store';
import { ref } from '@vue/composition-api';
import { editPassword } from '@/api/user';
import { Message } from 'element-ui';
import { useRouter } from '@/hooks';
import { RSAencrypt } from '@/util/encrypt.js';
import { debounce } from 'lodash-es';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const router = useRouter();
  const form = ref({
    password: undefined,
    newPassword: undefined,
    confirmPassword: undefined
  });
  const ruleObj = ref({
    password: {
      code: -1,
      message: '请输入原密码'
    },
    newPassword: {
      code: -1,
      message: '请输入新密码'
    },
    confirmPassword: {
      code: -1,
      message: '请确认新密码'
    }
  });
  const validatePassword = async field => {
    if (!form.value[field]) {
      ruleObj.value[field] = {
        code: 0,
        message: '请输入原密码'
      };
      return false;
    }
    const _param = {
      password: form.value.password
    };
    const param = RSAencrypt(JSON.stringify(_param));
    const res = await editPassword(param);
    const {
      data
    } = res || {};
    if (!data) {
      ruleObj.value[field] = {
        code: 0,
        message: '原密码不正确'
      };
      return false;
    }
    ruleObj.value[field] = {
      code: 1,
      message: '验证通过'
    };
    return true;
  };

  // 校验确认密码
  const validateConfirmPassword = field => {
    if (!form.value[field]) {
      ruleObj.value[field] = {
        code: 0,
        message: '请确认新密码'
      };
      return false;
    }
    if (form.value.newPassword !== form.value.confirmPassword) {
      ruleObj.value[field] = {
        code: 0,
        message: '两次密码不一致，请修改'
      };
      return false;
    }
    ruleObj.value[field] = {
      code: 1,
      message: '验证通过'
    };
    return true;
  };
  const validateNewPassword = field => {
    if (!form.value[field]) {
      ruleObj.value[field] = {
        code: 0,
        message: '请输入新密码'
      };
      return false;
    }
    const pwdReg = /^(?=.*[a-zA-Z])(?=.*\d).{6,18}$/;
    if (!pwdReg.test(form.value[field])) {
      ruleObj.value[field] = {
        code: 0,
        message: '不符合规则，请检查'
      };
      return false;
    }
    ruleObj.value[field] = {
      code: 1,
      message: '验证通过'
    };
    if (form.value.confirmPassword) {
      return validateConfirmPassword('confirmPassword');
    }
    return true;
  };

  // 校验数据
  const validateData = debounce(async field => {
    // 校验原密码是否正确
    if (field === 'password') {
      validatePassword('password');
    }
    // 校验新密码
    if (field === 'newPassword') {
      validateNewPassword('newPassword');
    }
    // 校验确认密码
    if (field === 'confirmPassword') {
      validateConfirmPassword('confirmPassword');
    }
  }, 500);

  // 修改密码
  const loading = ref(false);
  const handleSubmit = async () => {
    const res1 = await validatePassword('password');
    const res2 = validateNewPassword('newPassword');
    const res3 = validateConfirmPassword('confirmPassword');
    if (!res1 || !res2 || !res3) {
      return;
    }
    const data = {
      password: form.value.password,
      newPassword: form.value.newPassword.replace(/\s/g, '')
    };
    const param = RSAencrypt(JSON.stringify(data));
    loading.value = true;
    const res = await editPassword(param);
    loading.value = false;
    const {
      code
    } = res || {};
    if (code !== 0) {
      return;
    }
    Message.warning('密码已修改，请重新登录');
    store.dispatch('LogOut').then(() => {
      router.push({
        path: '/login?redirect=index'
      });
    });
  };
  return {
    form,
    ruleObj,
    validateData,
    loading,
    handleSubmit
  };
};
__sfc_main.components = Object.assign({
  ResetPwdItem
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 700;
    color: #333333;
    display: flex;
    align-items: flex-end;
  }
  .sub-title {
    margin-left: 25px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }

  ::v-deep .el-form-item {
    margin-bottom: 30px;
  }

  ::v-deep .el-button--success {
    background-color: #22c655;
    border-color: #22c655;
  }
  ::v-deep .el-button--success:focus {
    background-color: #25de5e;
    border-color: #25de5e;
  }
  ::v-deep .el-button--success:hover {
    background-color: #23d25a;
    border-color: #23d25a;
  }
</style>
